/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


/*
* Variant image for color swatches
*/
(function(){

    function init(colorName, product, container){
        //image height and width
        const height = 60;
        const width = 60;
        
        const colorSelector = container.querySelector(`[data-select-label="${colorName}" i]`);        
        
        if(colorSelector){
        
            const position = colorSelector.getAttribute('data-option-position');
            const index = parseInt(position, 10);

            //get color values
            const colorValues = Array.prototype.map.call(colorSelector.querySelectorAll('input'), obj => {
               return obj;
            })
        
            //check variants with featured media to find option that matches the Colour option value
            for (let i=0; i<product.variants.length; i++) {
                const variant = product.variants[i];
                
                if( variant.featured_media && variant.featured_media.preview_image ){
                
                    let value = variant.option1;
                    if(index === 2){
                       value = variant.option2;
                    }
                    if(index === 3){
                       value = variant.option3;
                    }            
                    
                    const foundMatch = colorValues.filter(function(elem){
                        return elem.value == value;
                    });
                    
                    
                    if(foundMatch.length){
                    
                        const label = foundMatch[0].parentElement.querySelector('label');
                        const size = `200x200_crop_center`;
                        const src = variant.featured_media.preview_image.src;
                        const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
                        
                        if( match && label) {
                            //add the size to the image
                            const suffix = match[0];
                            const prefix = src.split(suffix);
                            const image = `${prefix[0]}_${size}${suffix}`;
                          
                            //set background image property
                            label.classList.add('swatch');
                            label.style.setProperty('background-image', `url(${image})`);
                            label.style.setProperty('background-size', 'cover');
                            label.style.setProperty('width', `${width}px`);
                            label.style.setProperty('height', `${height}px`);    
                            label.style.setProperty('border-radius', '0');
                        }                
                    }
                
                }
            }
        
        }
    }
	
    //the name of the color options
    const colorNames = ["color", "colour", "style"];

    document.addEventListener("DOMContentLoaded", function(){
        const container = document.querySelectorAll('.product-section');
        container.forEach(function(productSection){
            const productJSON = productSection.querySelector("[data-product-json]");
            if (productJSON && productJSON.innerHTML !== '') {
                product = JSON.parse(productJSON.innerHTML);
            }            
            if(product != null && colorNames != null){
              colorNames.forEach(function(colorName){
                 init(colorName, product, productSection);
              });
            }
        });
    });
})();